import { HttpResponse } from "@angular/common/http";
import { Injectable, EventEmitter } from "@angular/core";
import { ApiGateway } from "api/api-gateway";
import { reject } from "lodash";
import { Observable } from "rxjs";

@Injectable()
export class ProfileService {
    constructor(private apiGateway: ApiGateway) { }

    editar(paciente): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .post("datasnap/rest/TPatientController/paciente/", paciente)
                .subscribe(async (res: HttpResponse<any>) => {
                    if (res.body) {                            
                    //    ProfileService.mudarEmailAtualizado.emit(true);                      
                     //  await new Promise((resolve) => setTimeout(resolve, 1000));
                     //ProfileService.mudarEmailAtualizado.emit(true);    
                        resolve(res.body);
                    } else {
                        resolve(res);
                        
                    }
                }, reject);
        });
    }

    buscar(idPaciente): Promise<any> {
        return new Promise((resolve, reject) => {
                 this.apiGateway
                .get(`patient/app/${idPaciente}`)
                .subscribe({
                    next: (res: HttpResponse<any>) => {                   
                        if (res.body) {
                            resolve(res.body);
                        } else {
                            resolve(res);
                        }
                    },
                    error: (err) => {
                        reject(err);
                    }
                });
        });
    }

   static mudarEmailAtualizado = new EventEmitter<boolean>();
}
